/**
 * `/payouts?month=&tab=` (decisions-log V67): «На руки» (what people get) or «Налоги» (employer and
 * project taxes).
 */
import { validateMonthSearch } from '../../lib/months';
import type { MonthSearch } from '../../lib/months';

export const PAYOUT_TABS = ['hand', 'taxes'] as const;
export type PayoutTab = (typeof PAYOUT_TABS)[number];

export const PAYOUT_TAB_LABELS: Readonly<Record<PayoutTab, string>> = { hand: 'На руки', taxes: 'Налоги' };

export interface PayoutsSearch extends MonthSearch {
  readonly tab?: PayoutTab;
}

const isTab = (value: unknown): value is PayoutTab => (PAYOUT_TABS as readonly unknown[]).includes(value);

export function validatePayoutsSearch(search: Record<string, unknown>): PayoutsSearch {
  return { ...validateMonthSearch(search), ...(isTab(search.tab) && search.tab !== 'hand' ? { tab: search.tab } : {}) };
}
